<template>
  <div :class="['editors-staff-header-skeleton', { _mobile: isMobile }]">
    <div class="editors-staff-header-skeleton__title"></div>
    <div class="editors-staff-header-skeleton__description">
      <div class="editors-staff-header-skeleton__description-line"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
const isMobile: boolean = useIsMobile();
</script>

<style lang="less">
.editors-staff-header-skeleton {
  .flex-column(@size-x3);

  &__title {
    .skeleton(60%, @size-x10);
  }

  &__description {
    .skeleton(100%, 50px);
  }

  &._mobile &__title {
    width: 90%;
    height: 30px;
  }
}
</style>
